// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Node-package browse card.
 *
 * Only what is specific to a package lives here. The card skeleton — .card,
 * .cardBody, .cardTitle, .publisher, .cardDescription, .tagRow, .tag,
 * .cardMeta, .cardActions and their parts — is the shared one in
 * ../catalog/CatalogBrowseLayout.module.css, which the dataset card already
 * used. This file used to restate all of it, and the two copies had already
 * drifted (the shared .metaRight lays its children out as a row; this file's
 * copy had lost that).
 *
 * Colours come from ../../styles/curioTokens.css.
 */

/* Declared here so \`.cardActive.card_<category>\` below is a valid compound
   selector within this module. The shared \`.cardActive\` in
   CatalogBrowseLayout.module.css sets the same raised shadow; both classes are
   applied together and agree, because both read the one token. */
.hfpZmZcOv_9WFQT8OIkW {
  box-shadow: var(--curio-shadow-browse-card-raised);
}

/* Card colour = node category, matching the canvas node border and the filter
   chip dots. Keys are \`primaryCategory()\`'s: data | computation | vis | package. */
.SkseUH0lgwtO1kEu1jtf        { background: var(--curio-category-data-fg); }
.K4r31p7P8qRtqHXl61yw { background: var(--curio-category-computation-fg); }
.zDAAvAJ54t0BLVCtBKVA         { background: var(--curio-category-vis-fg); }
.pu55O8CVNvuSkvfLScD1     { background: var(--curio-category-package-fg); }

.hfpZmZcOv_9WFQT8OIkW.PMVZ_KyQp5XKW96VM3QA        { border-color: var(--curio-category-data-fg); }
.hfpZmZcOv_9WFQT8OIkW.wtK7wxeMvyHxt2koDYlO { border-color: var(--curio-category-computation-fg); }
.hfpZmZcOv_9WFQT8OIkW.lw1OT01SO57K9uc2UZLg         { border-color: var(--curio-category-vis-fg); }
.hfpZmZcOv_9WFQT8OIkW.C1TG__zPVTnDWqa_LIUU     { border-color: var(--curio-category-package-fg); }

/* A model package, on the Model Catalog's page: ONE key, the model kind's
   colour, not one per runtime or type; the runtime is the strip's neutral
   badge. See --curio-kind-model-fg. */
.Mz7ok4qDFwCGXcND3Ghv             { background: var(--curio-kind-model-fg); }
.hfpZmZcOv_9WFQT8OIkW.VZMLayBpWajrJVWTjbJ5   { border-color: var(--curio-kind-model-fg); }

/* A model card's weights license: wraps, so it reads in full. */
.sUpDXA68OQr9j9Q8T5YR {
  margin: 8px 0 0;
  font-size: 11px;
  line-height: 1.35;
  color: var(--curio-text-meta);
}

.JihZ8GE6MqPmKvk_0te0 {
  background: var(--curio-role-update-bg);
  color: var(--curio-role-update-fg);
}

/* Card actions. The dataset card offers a link ("View details"); a package card
   offers a write, so it carries its own buttons rather than the shared link. */

.OM_7T666fArGL5qJSzw7 {
  height: 28px;
  border: 0;
  border-radius: var(--curio-radius-md);
  background: var(--curio-top-bar-bg);
  color: var(--curio-text-on-dark);
  padding: 0 16px;
  font-family: inherit;
  font-size: var(--curio-font-size-sm);
  font-weight: 700;
  cursor: pointer;
}

.OM_7T666fArGL5qJSzw7:hover:not(:disabled) {
  background: var(--curio-top-bar-bg-hover);
}

.yWs1cfb7LyHKNmE0VUWA {
  height: 28px;
  border: 0;
  border-radius: var(--curio-radius-md);
  background: var(--curio-role-update-fg);
  color: var(--curio-text-primary);
  padding: 0 16px;
  font-family: inherit;
  font-size: var(--curio-font-size-sm);
  font-weight: 700;
  cursor: pointer;
}

.yWs1cfb7LyHKNmE0VUWA:hover:not(:disabled) {
  background: #e99a5a;
}

.OM_7T666fArGL5qJSzw7:disabled,
.yWs1cfb7LyHKNmE0VUWA:disabled {
  opacity: 0.55;
  cursor: default;
}
`, "",{"version":3,"sources":["webpack://./src/pages/catalog/PackageBrowseCard.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;EAWE;;AAEF;;;iEAGiE;AACjE;EACE,kDAAkD;AACpD;;AAEA;mFACmF;AACnF,+BAAqB,yCAAyC,EAAE;AAChE,wBAAqB,gDAAgD,EAAE;AACvE,gCAAqB,wCAAwC,EAAE;AAC/D,4BAAqB,4CAA4C,EAAE;;AAEnE,oDAA+B,2CAA2C,EAAE;AAC5E,6CAA+B,kDAAkD,EAAE;AACnF,qDAA+B,0CAA0C,EAAE;AAC3E,iDAA+B,8CAA8C,EAAE;;AAE/E;;sCAEsC;AACtC,oCAA2B,sCAAsC,EAAE;AACnE,+CAA2B,wCAAwC,EAAE;;AAErE,gEAAgE;AAChE;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;+EAC+E;;AAE/E;EACE,YAAY;EACZ,SAAS;EACT,qCAAqC;EACrC,mCAAmC;EACnC,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,qCAAqC;EACrC,uCAAuC;EACvC,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,eAAe;AACjB","sourcesContent":["/* Node-package browse card.\n *\n * Only what is specific to a package lives here. The card skeleton — .card,\n * .cardBody, .cardTitle, .publisher, .cardDescription, .tagRow, .tag,\n * .cardMeta, .cardActions and their parts — is the shared one in\n * ../catalog/CatalogBrowseLayout.module.css, which the dataset card already\n * used. This file used to restate all of it, and the two copies had already\n * drifted (the shared .metaRight lays its children out as a row; this file's\n * copy had lost that).\n *\n * Colours come from ../../styles/curioTokens.css.\n */\n\n/* Declared here so `.cardActive.card_<category>` below is a valid compound\n   selector within this module. The shared `.cardActive` in\n   CatalogBrowseLayout.module.css sets the same raised shadow; both classes are\n   applied together and agree, because both read the one token. */\n.cardActive {\n  box-shadow: var(--curio-shadow-browse-card-raised);\n}\n\n/* Card colour = node category, matching the canvas node border and the filter\n   chip dots. Keys are `primaryCategory()`'s: data | computation | vis | package. */\n.strip_data        { background: var(--curio-category-data-fg); }\n.strip_computation { background: var(--curio-category-computation-fg); }\n.strip_vis         { background: var(--curio-category-vis-fg); }\n.strip_package     { background: var(--curio-category-package-fg); }\n\n.cardActive.card_data        { border-color: var(--curio-category-data-fg); }\n.cardActive.card_computation { border-color: var(--curio-category-computation-fg); }\n.cardActive.card_vis         { border-color: var(--curio-category-vis-fg); }\n.cardActive.card_package     { border-color: var(--curio-category-package-fg); }\n\n/* A model package, on the Model Catalog's page: ONE key, the model kind's\n   colour, not one per runtime or type; the runtime is the strip's neutral\n   badge. See --curio-kind-model-fg. */\n.strip_model             { background: var(--curio-kind-model-fg); }\n.cardActive.card_model   { border-color: var(--curio-kind-model-fg); }\n\n/* A model card's weights license: wraps, so it reads in full. */\n.weightsLicense {\n  margin: 8px 0 0;\n  font-size: 11px;\n  line-height: 1.35;\n  color: var(--curio-text-meta);\n}\n\n.tagUpdate {\n  background: var(--curio-role-update-bg);\n  color: var(--curio-role-update-fg);\n}\n\n/* Card actions. The dataset card offers a link (\"View details\"); a package card\n   offers a write, so it carries its own buttons rather than the shared link. */\n\n.installButton {\n  height: 28px;\n  border: 0;\n  border-radius: var(--curio-radius-md);\n  background: var(--curio-top-bar-bg);\n  color: var(--curio-text-on-dark);\n  padding: 0 16px;\n  font-family: inherit;\n  font-size: var(--curio-font-size-sm);\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.installButton:hover:not(:disabled) {\n  background: var(--curio-top-bar-bg-hover);\n}\n\n.updateButton {\n  height: 28px;\n  border: 0;\n  border-radius: var(--curio-radius-md);\n  background: var(--curio-role-update-fg);\n  color: var(--curio-text-primary);\n  padding: 0 16px;\n  font-family: inherit;\n  font-size: var(--curio-font-size-sm);\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.updateButton:hover:not(:disabled) {\n  background: #e99a5a;\n}\n\n.installButton:disabled,\n.updateButton:disabled {\n  opacity: 0.55;\n  cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardActive": `hfpZmZcOv_9WFQT8OIkW`,
	"strip_data": `SkseUH0lgwtO1kEu1jtf`,
	"strip_computation": `K4r31p7P8qRtqHXl61yw`,
	"strip_vis": `zDAAvAJ54t0BLVCtBKVA`,
	"strip_package": `pu55O8CVNvuSkvfLScD1`,
	"card_data": `PMVZ_KyQp5XKW96VM3QA`,
	"card_computation": `wtK7wxeMvyHxt2koDYlO`,
	"card_vis": `lw1OT01SO57K9uc2UZLg`,
	"card_package": `C1TG__zPVTnDWqa_LIUU`,
	"strip_model": `Mz7ok4qDFwCGXcND3Ghv`,
	"card_model": `VZMLayBpWajrJVWTjbJ5`,
	"weightsLicense": `sUpDXA68OQr9j9Q8T5YR`,
	"tagUpdate": `JihZ8GE6MqPmKvk_0te0`,
	"installButton": `OM_7T666fArGL5qJSzw7`,
	"updateButton": `yWs1cfb7LyHKNmE0VUWA`
};
export default ___CSS_LOADER_EXPORT___;
